import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ReportIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M1.574 1.03a.786.786 0 0 1 .972.556L5.97 13.978a.806.806 0 0 1-.544.992.786.786 0 0 1-.972-.556L1.03 2.022a.806.806 0 0 1 .544-.992"
			clipRule="evenodd"
		></path>
		<path
			fill="currentColor"
			d="M7.885 7.008c-1.026-.092-2.129.6-2.385.997L3.75 2c.256-.396 1.276-1.084 2.301-.992 1.282.115 2.308.805 2.532.997S9.77 3 11.211 3c1.154 0 1.785-.664 1.956-.996L15 8v.004c-.17.332-.801.996-1.955.996-1.442 0-2.404-.805-2.628-.996-.225-.192-1.25-.882-2.532-.997"
		></path>
	</svg>
))
